<script setup lang="ts">
import { useQuasar } from 'quasar';
import SchoolRegisterSignInView from 'src/modules/School/views/SchoolRegisterSignInView/SchoolRegisterSignInView.vue';
import FlashAuthPageDecoration from 'src/shared/components/FlashAuthPageDecoration/FlashAuthPageDecoration.vue';
import { styleFn } from 'shared/composables/usePage';

const $q = useQuasar();
// FlashStudies auth is dark-on-purple in every theme, the mirror of the SET App
// screens forcing dark. Auth screens ignore the user's theme preference by design.
$q.dark.set(false);
</script>

<template>
  <q-page
    padding
    :style-fn="styleFn"
    class="column bg-primary"
  >
    <div class="col fit q-pt-xl">
      <SchoolRegisterSignInView />
      <FlashAuthPageDecoration v-if="!$q.platform.is.mobile" />
    </div>
  </q-page>
</template>
